export default __webpack_public_path__ + "static/media/logowhite.043d71b9.png";